window.addEventListener("scroll", function() {
  var header = document.querySelector("header.header");
  if (window.scrollY > 50) { // Adjust the scroll distance as needed
    header.classList.add("scrolled");
  } else {
    header.classList.remove("scrolled");
  }
});


function isMobile() {
  return window.innerWidth <= 768; // Adjust this value as needed
}

function handleClick(event) {
  // Toggle 'active' class on the clicked heading
  this.classList.toggle('active');

  // Get all footer headings
  const footerHeadings = document.querySelectorAll('.footer-block__heading');

  // Loop through and remove 'active-footer-block' from other elements
  footerHeadings.forEach(h => {
    const nextElement = h.nextElementSibling;
    if (nextElement && nextElement.classList.contains('active-footer-block') && h !== this) {
      nextElement.classList.remove('active-footer-block');
    }
  });

  // Toggle 'active-footer-block' on the associated content of the clicked heading
  const nextElement = this.nextElementSibling;
  if (nextElement) {
    nextElement.classList.toggle('active-footer-block');
  }
}

function setupAccordion() {
  const footerHeadings = document.querySelectorAll('.footer-block__heading');

  footerHeadings.forEach(heading => {
    heading.removeEventListener('click', handleClick);
    heading.addEventListener('click', handleClick);
  });
}

function removeAccordion() {
  const footerHeadings = document.querySelectorAll('.footer-block__heading');

  footerHeadings.forEach(heading => {
    heading.removeEventListener('click', handleClick);
  });
}

function manageFooterAccordion() {
  if (isMobile()) {
    setupAccordion();
  } else {
    removeAccordion();
  }
}

// Run on initial load
document.addEventListener('DOMContentLoaded', manageFooterAccordion);

// Run when the window is resized
window.addEventListener('resize', manageFooterAccordion);
